/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-10-23 10:43:48 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-10-23 11:07:57
 */

import UserSelector from "./UserSelector";

export default UserSelector;



// WEBPACK FOOTER //
// ./app/components/Base/UserSelector/index.js